import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomParty} from '../../../graphql/groups.datatypes';
import {gqlRoomParty} from '../getRoomParty.api';

export interface SplitRoomInput {
    data: {
        id: number
        new_room: number[]
    }
}

interface SplitRoomData {
    splitRoom: RoomParty
}

export const SPLIT_ROOM_MUTATION = gql`
    mutation splitRoom($data: SplitRoomInput!) {
        splitRoom(data: $data) {
            ${gqlRoomParty}
        }
    }
`;

export const splitRoom = () => useMutation<SplitRoomData, SplitRoomInput>(
    SPLIT_ROOM_MUTATION,
    {
        update: updateCacheByType('RoomParty'),
    }
);

export default splitRoom;